export const WIDGET_TYPE_QUESTIONNAIRE = 'questionnaire';
export const WIDGET_TYPE_HOMUNCULUS = 'homunculus';
export const WIDGET_TYPE_DENTAL_CHART_V1 = 'dental/dentalChart/v1';
export const WIDGET_TYPE_DENTAL_CHART_V2 = 'dental/dentalChart/v2';
export const WIDGET_TYPE_DENTAL_CHART_V3 = 'dental/dentalChart/v3';
export const WIDGET_TYPE_DENTAL_CHART_SUMMARY = 'dental/dentalChartSummary/v1';
